module.exports = __webpack_public_path__ + "img/hand.060b35e9.png";